import { useEffect, useState, useContext, useCallback } from "react";
import learnerService from "../../services/learner.service";
import styles from "./ListLearners.module.css";

import * as dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquare,
  faSquareCheck,
  faCircleCheck,
  faCircle,
  faPenToSquare,
} from "@fortawesome/free-regular-svg-icons";
import { AuthContext } from "../../contexts/auth.context";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

function ListLearnersPage() {
  const { section } = useParams();
  const [searchParams] = useSearchParams();
  const edit = searchParams.get("edit");
  const navigate = useNavigate();
  const [learners, setLearners] = useState([]);
  const [numLearnersToday, setNumLearnersToday] = useState(0);
  const [numCouncilLearnersToday, setNumCouncilLearnersToday] = useState(0);
  const [today, setToday] = useState(dayjs().format("DD-MM-YYYY"));
  useContext(AuthContext);

  const _setLearners = useCallback((learnersUpdated) => {
    setLearners(learnersUpdated);
    setNumLearnersToday(
      learnersUpdated.filter(
        (learner) => learner.presence.indexOf(today) !== -1
      ).length
    );
    setNumCouncilLearnersToday(
      learnersUpdated.filter(
        (learner) => learner.councils.indexOf(today) !== -1
      ).length
    );
  }, [today]);

  useEffect(() => {
    const fetchLearners = async () => {
      const learners = await learnerService.getLearners(section);

      _setLearners(learners.data);
    };
    fetchLearners();
  }, [section, _setLearners]);

  const _handleCheck = async (ev, id) => {
    _check(id);
  };

  const _handleCouncilCheck = async (ev, id) => {
    _check(id, true);
  };

  const _check = async (id, council = false) => {
    try {
      const response = await learnerService.check(id, today, council);

      const _id = response?.data?._id;
      const learnersUpdated = learners.map((learner) => {
        if (learner._id === _id) {
          learner[council ? "councils" : "presence"].push(today);
        }

        return learner;
      });
      _setLearners(learnersUpdated);
    } catch {}
  };

  const _handleUncheck = async (ev, id) => {
    _uncheck(id);
  };

  const _handleCouncilUncheck = async (ev, id) => {
    _uncheck(id, true);
  };

  const _uncheck = async (id, council = false) => {
    try {
      const response = await learnerService.uncheck(id, today, council);
      const _id = response?.data?._id;
      const learnersUpdated = learners.reduce((acc, learner) => {
        if (learner._id === _id) {
          const propertyName = council ? "councils" : "presence";
          learner[propertyName] = learner[propertyName].filter(
            (day) => day !== today
          );
        }

        return [...acc, learner];
      }, []);
      _setLearners(learnersUpdated);
    } catch {}
  };

  const _goPresence = () => {
    navigate(`/listLearnersPresence/${section}`);
  };

  const _changeDay = (e) => {
    setToday(dayjs(e.target.value).format("DD-MM-YYYY"));
  };

  const _handleEdit = (ev, id) => {
    navigate(`/editLearner/${id}`);
  };

  return (
    <>
      <div className={styles["list-container"]}>
        <ScreenHeader title={section} />
        {!edit ? (
          <>
            <button className={styles["presence-follow"]} onClick={_goPresence}>
              Seguimiento de asistencia
            </button>
            <input
              value={today.split("-").reverse().join("-")}
              max={dayjs().format("YYYY-MM-DD")}
              type="date"
              className={styles["date-select"]}
              onChange={_changeDay}
            ></input>
            <p>
              Han venido <strong>{numLearnersToday}</strong> de{" "}
              <strong>{learners.length}</strong> {section}
            </p>
          </>
        ) : (
          ""
        )}

        {section === "Scouters" && !edit ? (
          <p>
            Han venido al consejo <strong>{numCouncilLearnersToday}</strong> de{" "}
            <strong>{learners.length}</strong> {section}
          </p>
        ) : (
          ""
        )}
        <div className={styles["elementos-lista"]}>
          {learners.length ? (
            learners.map((learner) => (
              <div className={styles["learner-elemento"]} key={learner._id}>
                <div className={styles.name}>{learner.name}</div>
                <div className={styles["learner-acciones"]}>
                  {edit ? (
                    <FontAwesomeIcon
                      className={styles.editButton}
                      icon={faPenToSquare}
                      onClick={(ev) => _handleEdit(ev, learner._id)}
                    />
                  ) : learner.presence.includes(today) ? (
                    <FontAwesomeIcon
                      className={`${styles.check} ${styles.checked}`}
                      icon={faSquareCheck}
                      onClick={(ev) => _handleUncheck(ev, learner._id)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      className={styles.check}
                      icon={faSquare}
                      onClick={(ev) => _handleCheck(ev, learner._id)}
                    />
                  )}
                </div>
                {section === "Scouters" && !edit ? (
                  learner.councils.includes(today) ? (
                    <FontAwesomeIcon
                      className={`${styles.check} ${styles.gold}`}
                      icon={faCircleCheck}
                      onClick={(ev) => _handleCouncilUncheck(ev, learner._id)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      className={styles.check}
                      icon={faCircle}
                      onClick={(ev) => _handleCouncilCheck(ev, learner._id)}
                    />
                  )
                ) : (
                  ""
                )}
              </div>
            ))
          ) : (
            <p>No hay socios en esta sección</p>
          )}
        </div>
      </div>
    </>
  );
}

export default ListLearnersPage;
